import { ROWS_PER_PAGE_OPTIONS } from "consts/table";
import useFetchResource, { type UseFetchResourceArg } from "hooks/useFetchResource";

export const useRequest = (simpleRequestSettings?: UseFetchResourceArg) => {
    const request = useFetchResource({
        shouldFetchAll: true,
        perPage: ROWS_PER_PAGE_OPTIONS.at(-1),
        ...simpleRequestSettings,
    });

    return (requestHandler: (searchQueryParams?: string) => Promise<Response>) =>
        request(requestHandler);
};

export default useRequest;
